import { render } from "./video-overflow.vue?vue&type=template&id=df86a944"
import script from "./video-overflow.vue?vue&type=script&setup=true&lang=ts"
export * from "./video-overflow.vue?vue&type=script&setup=true&lang=ts"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "df86a944"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('df86a944', script)) {
    api.reload('df86a944', script)
  }
  
  module.hot.accept("./video-overflow.vue?vue&type=template&id=df86a944", () => {
    api.rerender('df86a944', render)
  })

}

script.__file = "resources/scripts/components/video-overflow.vue"

export default script